(() => {
  let cached, cachedAt = 0, pending;
  async function catalog(path) {
    if (cached && Date.now() - cachedAt < 60000) return cached;
    if (pending) return pending;
    pending = (async () => {
      const products = new Map();
      let next = new URL(path, location.origin);
      next.searchParams.set('view', 'bn-size-data');
      const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
      if (previewTheme) next.searchParams.set('preview_theme_id', previewTheme);
      const visited = new Set();
      while (next) {
        if (visited.has(next.href) || next.origin !== location.origin) throw new Error('Invalid pagination');
        visited.add(next.href);
        const response = await fetch(next.href, {cache: 'no-store', credentials: 'same-origin', headers: {Accept: 'text/html'}});
        if (!response.ok) throw new Error('Catalog unavailable');
        const page = await response.json();
        if (!Array.isArray(page.products)) throw new Error('Invalid catalog');
        page.products.forEach(product => products.set(String(product.id), product));
        next = page.next ? new URL(page.next, location.origin) : null;
        if (next) {
          next.searchParams.set('view', 'bn-size-data');
          if (previewTheme) next.searchParams.set('preview_theme_id', previewTheme);
        }
      }
      cached = [...products.values()];
      cachedAt = Date.now();
      return cached;
    })();
    try { return await pending; } finally { pending = null; }
  }
  function setup(scope = document) {
    scope.querySelectorAll('[data-size-finder]').forEach(panel => {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      const form = panel.querySelector('[data-size-form]'), status = panel.querySelector('[data-size-status]');
      const results = panel.querySelector('[data-size-results]'), more = panel.querySelector('[data-size-more]');
      const messages = JSON.parse(panel.querySelector('[data-size-messages]').textContent);
      const submit = form.querySelector('[type="submit"]');
      let matches = [], shown = 0, revision = 0;
      function render() {
        matches.slice(shown, shown + 8).forEach(({product, variant}) => {
          const card = document.createElement('a');
          card.className = 'bn-size-finder__card';
          const url = new URL(product.url, location.origin);
          url.searchParams.set('variant', variant.id);
          card.href = url.href;
          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image; image.alt = product.title; image.loading = 'lazy'; image.width = 300; image.height = 300;
            card.append(image);
          }
          const body = document.createElement('div');
          for (const [tag, text] of [['h3', product.title], ['p', variant.title], ['strong', variant.price]]) {
            const node = document.createElement(tag); node.textContent = text; body.append(node);
          }
          card.append(body); results.append(card);
        });
        shown += 8;
        more.hidden = shown >= matches.length;
      }
      more.addEventListener('click', render);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const current = ++revision;
        const raw = form.elements.size.value.trim().replace(',', '.');
        const size = Number(raw), system = form.elements.system.value;
        results.replaceChildren(); more.hidden = true;
        if (!/^\d+(?:\.\d+)?$/.test(raw) || size <= 0) { status.textContent = messages.invalid; return; }
        status.textContent = messages.loading; submit.disabled = true; results.setAttribute('aria-busy', 'true');
        try {
          const products = await catalog(panel.dataset.catalogUrl);
          if (current !== revision) return;
          matches = products.map(product => ({product, variant: product.variants.find(variant => window.BNSizes.matches(variant.title, system, size))})).filter(match => match.variant);
          shown = 0;
          status.textContent = matches.length ? messages.found.replace('__count__', matches.length) : messages.empty;
          render();
        } catch (_) { if (current === revision) status.textContent = messages.error; }
        finally { if (current === revision) { submit.disabled = false; results.removeAttribute('aria-busy'); } }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
